'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = lengthValidator;


var defaultOptions = { min: 1, max: 1024 * 1024 };
function lengthValidator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
  var min = options.min,
      max = options.max,
      exact = options.exact,
      message = options.message;


  if (typeof exact === 'number') {
    return function (input) {
      return warnMissingLength(input, message) || warnExactLength(input, exact, message);
    };
  } else if (typeof min === 'number' && typeof max === 'number') {
    return function (input) {
      return warnMissingLength(input, message) || warnMinLength(input, min, message) || warnMaxLength(input, max, message);
    };
  } else if (typeof min === 'number') {
    return function (input) {
      return warnMissingLength(input, message) || warnMinLength(input, min, message);
    };
  } else if (typeof max === 'number') {
    return function (input) {
      return warnMissingLength(input, message) || warnMaxLength(input, max, message);
    };
  } else {
    throw new Error("Length Validator requires 'min' and/or 'max' or 'exact' properties.");
  }
}

function warnMissingLength(input, message) {
  if (input == null || typeof input.length !== 'number') {
    return message || 'must have a length';
  }
}

function warnExactLength(input, exact, message) {
  if (input.length !== exact) {
    return message || 'length must be exactly: ' + exact;
  }
}

function warnMinLength(input, min, message) {
  if (input.length < min) {
    return message || 'length must be at least: ' + min;
  }
}

function warnMaxLength(input, max, message) {
  if (input.length > max) {
    return message || 'length must be at most: ' + max;
  }
}


//////////////////
// WEBPACK FOOTER
// ../flow-runtime-validators/lib/length.js
// module id = 294
// module chunks = 0